import {
    Menu,
    MenuItem,
    StyleRulesCallback,
    WithStyles,
    withStyles
} from "@material-ui/core";
import * as React from "react";

import { SelectItem } from "./SLSelectContainer";
import SLTextFieldNew, {SLTextFieldType} from "../Input/SLTextFieldNew";

interface IProps {
    className?: string;
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
    items: SelectItem[];
    selectedItem?: SelectItem;
    onItemSelected: (item: SelectItem) => void;
    disabled?: boolean;
    label?: string;
    placeholder?: string;
    renderLabel?: (displayString: string) => React.ReactElement<any>;
    fullWidth: boolean;
    isErrorOnSameLine?: boolean

}

const styles: StyleRulesCallback = ({ palette, breakpoints }) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "space-between",
        position: "relative",
        cursor: "pointer",
        flexShrink: 0,
        width: "30%",
    },
    textField: {
        cursor: "pointer",
        flex: 1,
        [breakpoints.down("sm")]: {
            marginBottom: 15,
        }
    },
    disabled: {
        cursor: "default"
    },
    menuItemRoot: {
        fontSize: 14,
        height: 18,
        "&$menuItemSelected, &$menuItemSelected:focus": {
            fontWeight: "bold",
            backgroundColor: "transparent!important",
        },
        "&:hover": {
            backgroundColor: "#E3F2F8"
        }
    },
    menuItemSelected: {}
});

@(withStyles(styles) as any)
export default class SLSelectNew extends React.Component<
    IProps & Partial<WithStyles<any>>
    > {
    private ref: any;

    public render() {
        const { classes, onOpen, className, isOpen, disabled } = this.props;

        return (
            <div
                className={`${classes!.container} ${className} ${disabled &&
                classes!.disabled}`}
                onClick={!isOpen && !disabled ? onOpen : undefined}
                ref={this.saveRef}
            >
                {this.renderLabel()}
                {this.renderMenu()}
            </div>
        );
    }

    private renderLabel() {
        const {
            renderLabel,
            selectedItem,
            label,
            placeholder,
            classes,
            fullWidth,
            disabled,
            isErrorOnSameLine
        } = this.props;

        const displayString = selectedItem
            ? selectedItem.displayString
            : placeholder || "Select";

        if (renderLabel) {
            return renderLabel(displayString);
        } else {
            return (
                <SLTextFieldNew
                    label={label}
                    textFieldProps={{
                        value: displayString,
                        fullWidth,
                        disabled
                    }}
                    isErrorOnSameLine={isErrorOnSameLine}
                    className={classes!.textField}
                    isDefaultSelection={!selectedItem}
                    slType={SLTextFieldType.Select}
                />
            );
        }
    }

    private saveRef = (ref: any) => (this.ref = ref);

    private renderMenu() {
        const { isOpen, onClose, items, selectedItem, classes } = this.props;

        return (
            <Menu
                id="menu-appbar"
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
                anchorEl={this.ref}
                open={isOpen}
                onClose={onClose}
            >
                {items.map((item: SelectItem, index: number) => (
                    <MenuItem
                        classes={{
                            root: classes!.menuItemRoot,
                            selected: classes!.menuItemSelected
                        }}
                        id={item.value}
                        className={classes!.menuItem}
                        onClick={this.onItemSelected}
                        key={index}
                        selected={selectedItem ? selectedItem.value === item.value : false}
                    >
                        {item.displayString}
                    </MenuItem>
                ))}
            </Menu>
        );
    }

    private onItemSelected = (event: any) => {
        const { items, onItemSelected } = this.props;
        const value = event.target.id;
        const selectedItem = items.filter(item => item.value === value)[0];
        onItemSelected(selectedItem);
    };
}



// WEBPACK FOOTER //
// ./src/components/SLSelect/SLSelectNew.tsx